import createListViewContext, { type FilterValues } from 'global/helpers/createListViewContext'

export interface UsersFilterValues extends FilterValues {
  keywords: string[]
}

const defaultFilters: UsersFilterValues = {
  keywords: [],
}

const { ListViewProvider, useListView } = createListViewContext(defaultFilters)

export { ListViewProvider as UsersViewProvider, useListView as useUsersView }
